import { Directive, HostListener, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNextSection]'
})
export class NextSectionDirective {
  nodeList: any;
  constructor(
    private renderer: Renderer2, private el: ElementRef

  ) {

    this.nodeList = this.renderer.selectRootElement(el);
    const div = this.renderer.createElement('div');
  const text = this.renderer.createText('Hello world!');

  this.renderer.appendChild(div, text);
  this.renderer.appendChild(this.el.nativeElement, div);
  }


  @HostListener('click') onclick() {
    alert('Host Element Clicked');

  }


}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-course/next-section.directive.ts